import { cn } from '../../lib/utils'
import { DIFF_TONE_CLASSES, type DiffTone } from './KindBadge'

export interface CountChip {
  /** Fully formatted chip text, e.g. "3 structural changes". */
  text: string
  tone: DiffTone
  /** Optional hover explanation. */
  title?: string
}

/** The summary strip above a diff table. Callers omit zero-count chips. */
export function CountChips({ chips }: { chips: CountChip[] }) {
  if (chips.length === 0) return null
  return (
    <div className="flex flex-wrap gap-1.5 text-10">
      {chips.map((chip) => (
        <span
          key={chip.text}
          title={chip.title}
          className={cn(
            'rounded-sm px-1.5 py-0.5 font-medium tracking-wide uppercase',
            DIFF_TONE_CLASSES[chip.tone]
          )}
        >
          {chip.text}
        </span>
      ))}
    </div>
  )
}
